// Copyright © 2019-2026 Focal Systems. All rights reserved.

import type { DeviceEntry } from "@/api/hooks/use-devices";

type MountSource = Pick<DeviceEntry, "onHinge" | "onCeiling">;

export type MountKind = "hinge" | "ceiling" | "standard";

export type MountLabels = Record<MountKind, string>;

export const MOUNT_LABELS_EN: MountLabels = { hinge: "hinge", ceiling: "ceiling", standard: "standard" };

export function formatMods(mods: string[] | undefined): string {
  return mods && mods.length > 0 ? mods.join(", ") : "";
}

// Both flags unset means the install flow never recorded mounts (null); both false is an explicit standard mount.
export function mountKinds(device: MountSource): MountKind[] | null {
  if (device.onHinge == null && device.onCeiling == null) return null;
  const mounts: MountKind[] = [];
  if (device.onHinge) mounts.push("hinge");
  if (device.onCeiling) mounts.push("ceiling");
  return mounts.length > 0 ? mounts : ["standard"];
}

export function formatMount(device: MountSource, labels: MountLabels): string {
  return (
    mountKinds(device)
      ?.map((kind) => labels[kind])
      .join(", ") ?? ""
  );
}
